import script from "./TagMergeModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagMergeModal.vue?vue&type=script&setup=true&lang=ts"

import "./TagMergeModal.vue?vue&type=style&index=0&id=7e337ab0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e337ab0"]])

export default __exports__